module.exports = __webpack_public_path__ + "img/logo-setwan.b6b5d73.png";